import { Component, OnInit, Renderer2, ViewChild, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { AuthService } from 'app/services/auth.service';
import { DataService } from 'app/services/data.service';
import { TiendaService } from 'app/services/tienda.service';

@Component({
  moduleId: module.id,
  selector: 'navbar-cmp',
  templateUrl: 'navbar.component.html',
  styles: [
    '.username { padding: 5px 0px 5px 15px; font-weight: 500; }',
    `/* Botón Mi Tienda - Diseño premium y moderno */
    .navbar-store-btn {
      background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%) !important;
      border: 1px solid rgba(102, 97, 91, 0.15) !important;
      color: #66615b !important;
      height: 38px !important;
      padding: 8px 14px !important;
      border-radius: 20px !important;
      font-weight: 500 !important;
      font-size: 12px !important;
      box-shadow: 0 2px 6px rgba(102, 97, 91, 0.08) !important;
      transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
      display: inline-flex !important;
      align-items: center !important;
      justify-content: center !important;
      gap: 6px !important;
      text-transform: none !important;
      letter-spacing: 0.2px !important;
      margin-right: 12px !important;
      position: relative !important;
      overflow: hidden !important;
    }
    
    /* Indicador de estado activo */
    .navbar-store-btn::before {
      content: '' !important;
      position: absolute !important;
      top: 0 !important;
      left: 0 !important;
      right: 0 !important;
      height: 2px !important;
      background: linear-gradient(90deg, #102dd3, #51bcda) !important;
      border-radius: 20px 20px 0 0 !important;
      opacity: 0.7 !important;
    }
    
    .navbar-store-btn:hover {
      background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%) !important;
      border-color: rgba(102, 97, 91, 0.25) !important;
      color: #102dd3 !important;
      transform: translateY(-1px) !important;
      box-shadow: 0 4px 12px rgba(102, 97, 91, 0.15) !important;
    }
    
    .navbar-store-btn:hover::before {
      opacity: 1 !important;
      height: 3px !important;
    }
    
    .navbar-store-btn:hover i {
      color: #102dd3 !important;
      transform: scale(1.05) !important;
    }
    
    .navbar-store-btn:focus {
      background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%) !important;
      border-color: rgba(16, 45, 211, 0.3) !important;
      color: #102dd3 !important;
      box-shadow: 0 0 0 3px rgba(16, 45, 211, 0.1) !important;
      outline: none !important;
    }
    
    .navbar-store-btn:active {
      background: linear-gradient(135deg, #f0f0f0 0%, #e8e9ea 100%) !important;
      border-color: rgba(102, 97, 91, 0.4) !important;
      color: #102dd3 !important;
      transform: translateY(0px) !important;
      box-shadow: 0 2px 4px rgba(102, 97, 91, 0.2) inset !important;
    }
    
    .navbar-store-btn i {
      font-size: 15px !important;
      color: #66615b !important;
      transition: all 0.3s ease !important;
    }
    
    .navbar-store-btn span {
      font-weight: 500 !important;
      transition: all 0.3s ease !important;
    }
    
    /* Responsive mejorado */
    @media (max-width: 991px) {
      .navbar-store-btn {
        padding: 8px 12px !important;
        font-size: 11px !important;
      }
    }
    
    @media (max-width: 767px) {
      .navbar-store-btn {
        padding: 8px 10px !important;
        min-width: 38px !important;
        height: 36px !important;
        border-radius: 18px !important;
      }
      
      .navbar-store-btn i {
        font-size: 14px !important;
      }
    }
    
    /* Animación sutil de entrada */
    @keyframes storeButtonFadeIn {
      from {
        opacity: 0;
        transform: translateX(-10px);
      }
      to {
        opacity: 1;
        transform: translateX(0);
      }
    }
    
    .navbar-store-btn {
      animation: storeButtonFadeIn 0.4s ease-out !important;
    }`,
  ],
})
export class NavbarComponent implements OnInit {
  location: Location;
  private nativeElement: Node;
  private toggleButton;
  private sidebarVisible: boolean;
  verTienda: boolean = false;
  urlTienda = '';
  nombreTienda = '';
  statusTienda = '';

  public isCollapsed = true;
  @ViewChild('navbar-cmp', { static: false }) button;

  constructor(
    location: Location,
    private element: ElementRef,
    private router: Router,
    private autService: AuthService,
    public dataService: DataService,
    private tiendaService: TiendaService
  ) {
    this.location = location;
    this.nativeElement = element.nativeElement;
    this.sidebarVisible = false;
  }

  cerrarSesion() {
    this.autService.cerrarSesion();
  }

  ngOnInit() {
    var navbar: HTMLElement = this.element.nativeElement;
    this.toggleButton = navbar.getElementsByClassName('navbar-toggle')[0];
    this.router.events.subscribe(event => {
      this.sidebarClose();
    });

    // Suscribirse a la información de la tienda desde DataService
    this.dataService.storeInfo.subscribe(storeInfo => {
      this.verTienda = storeInfo.hasStore && storeInfo.status === 'active';
      this.urlTienda = storeInfo.url;
      this.nombreTienda = storeInfo.name;
      this.statusTienda = storeInfo.status;
    });

    // Obtener información de tienda al inicializar
    this.dataService.getStoreInfo();
  }
  getTitle() {
    var titlee = this.location.prepareExternalUrl(this.location.path());
    if (titlee.charAt(0) === '#') {
      titlee = titlee.slice(1);
    }
    let listTitles;
    for (var item = 0; item < this.dataService.ROUTES.values.length; item++) {
      if (listTitles[item].path === titlee) {
        return listTitles[item].title;
      }
    }
    return 'Dashboard';
  }

  getTienda() {
    this.tiendaService.getTienda().subscribe(
      res => {
        if (res) {
          this.verTienda = true;
          this.urlTienda = `https://${res.dominio}`;
        }
      },
      err => {
        console.log(err);
      }
    );
  }

  sidebarToggle() {
    if (this.sidebarVisible === false) {
      this.sidebarOpen();
    } else {
      this.sidebarClose();
    }
  }
  sidebarOpen() {
    const toggleButton = this.toggleButton;
    const html = document.getElementsByTagName('html')[0];
    const mainPanel = <HTMLElement>document.getElementsByClassName('main-panel')[0];
    setTimeout(function () {
      toggleButton.classList.add('toggled');
    }, 500);

    html.classList.add('nav-open');
    if (window.innerWidth < 991) {
      mainPanel.style.position = 'fixed';
    }
    this.sidebarVisible = true;
  }
  sidebarClose() {
    const html = document.getElementsByTagName('html')[0];
    const mainPanel = <HTMLElement>document.getElementsByClassName('main-panel')[0];
    if (window.innerWidth < 991) {
      setTimeout(function () {
        mainPanel.style.position = '';
      }, 500);
    }
    this.toggleButton.classList.remove('toggled');
    this.sidebarVisible = false;
    html.classList.remove('nav-open');
  }
  collapse() {
    this.isCollapsed = !this.isCollapsed;
    const navbar = document.getElementsByTagName('nav')[0];
    console.log(navbar);
    if (!this.isCollapsed) {
      navbar.classList.remove('navbar-transparent');
      navbar.classList.add('bg-white');
    } else {
      navbar.classList.add('navbar-transparent');
      navbar.classList.remove('bg-white');
    }
  }

  goToProfile() {
    const uid = this.dataService.getUID();
    this.router.navigate(['/configurar/user/profile/', uid]);
  }

  irTienda() {
    window.open(this.urlTienda, '_blank');
  }
}
